import { Anchor, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconExternalLink, IconSettings } from "@tabler/icons-react";
import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";

const ResellerCreatedModal = ({ domain }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(true);

  return (
    <Modal opened={opened} onClose={() => setOpened(false)} size={"lg"}>
      <Stack p={"lg"} pt={0}>
        <Text size="xl">{lang.white_labels.created_title}</Text>

        <Text size="md">{lang.white_labels.created_text}</Text>

        <Group wrap="nowrap" gap={"xl"} justify="end" mt={"xl"}>
          <Button
            onClick={() => setOpened(false)}
            size="md"
            variant="light"
            leftSection={<IconSettings />}
          >
            {lang.white_labels.continue_config}
          </Button>

          <Anchor target="_blank" href={`https://${domain}`}>
            <Button leftSection={<IconExternalLink />} size="md">
              {lang.white_labels.view_white_label}
            </Button>
          </Anchor>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ResellerCreatedModal;
